import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import bgimage from '../../../../images/raw_material/default_rawmaterial.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AddBanner = ({ show, onClose, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [name, setname] = useState('');
    const [description, setdescription] = useState('');
    const [errors, setErrors] = useState({});
    const [data_name, setData] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/banner`)
          .then(response => {
            setData(response.data.data.data.map(mode => mode.banner_name.toLowerCase()));
          })
          .catch(error => {
            console.log('There was an error fetching the data!', error);
          });
    }, []);

    const [file, setFile] = useState(null);
    const imageInputRef = useRef(null);


    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [fileerrors, setfileErrors] = useState([]);
    const handleFileChange = (selectedFiles) => {
        const maxFileSize = 2 * 1024 * 1024; // 2MB
        const allowedTypes = [
            "image/jpeg",
            "image/png",
        ];

        const newErrors = [];
        let validFile = null;

        // Check if at least one file is selected
        if (selectedFiles.length === 0) {
            setFile(null);
            setfileErrors([]);
            return;
        }

        const file = selectedFiles[0]; // only one file allowed

        if (!allowedTypes.includes(file.type)) {
            newErrors.push(`"${file.name}" is not a supported file type.`);
        } else if (file.size > maxFileSize) {
            newErrors.push(`"${file.name}" exceeds 2MB.`);
        } else {
            validFile = file;
        }

        setFile(validFile);
        setfileErrors(newErrors);
    };

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z0-9 ]+$/;

        if (!name.trim()) {
            newErrors.name = "This Field is Required.";
            // return newErrors;
        } else if (!regex.test(name)) {
            newErrors.name = "Not a Valid Name";
            // return newErrors;
        } else if (data_name.includes(name.trim().toLowerCase())) {
            newErrors.name = "This Name Alredy Exists";
            // return newErrors;
        }

        if (!file) {
            newErrors.file = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const formData = new FormData();

        // Append regular fields
        formData.append('banner_name', name);
        formData.append('description', description);
        if (file) {
            formData.append('banner_image', file);
        }

        axios.post(`${baseURL}/banner`, formData)
            .then(response => {
                onClose();
                refresh();
                // window.location.reload();
                toast.success("Banner Created Successfully!");
            })
            .catch(error => {
                onClose();
                console.log(error);
                toast.error("Banner Creation Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Banner</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Name" 
                                maxLength={100}
                                value={name} 
                                onChange={(e) => setname(formatName(e.target.value))} 
                            />
                            {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" 
                                maxLength={255}
                                value={description} 
                                onChange={(e) => setdescription(formatName(e.target.value))}
                            />
                        </div>
                        <div className='col-lg-12 mb-2'>
                            <label className="text-black font-w500 fs-7 d-block">Banner Image<span className="required">*</span></label>
                            <span className='fs-8 text-gray-800'>Size: </span>
                            <span className='fs-8 text-danger'>15 * 15</span>
                            <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                            <span className='fs-8 text-danger'>.png, .jpg</span>
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative px-0">
                                    <div className="avatar-preview h-80px w-100px border" style={{ borderRadius: '10px' }}>
                                        <img
                                            id="saveImageFile"
                                            src={file ? URL.createObjectURL(file) : bgimage}
                                            alt={file ? file.name : 'Default Avatar'}
                                            className="p-1 h-80px w-100px"
                                        />
                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFileChange(e.target.files)}
                                            ref={imageInputRef}
                                        />
                                        <div className="mt-2 d-flex justify-content-center gap-3">
                                            <Button
                                                className="btn-xs mb-2"
                                                variant="success"
                                                onClick={() => imageInputRef.current.click()}
                                            >
                                                <span className="">
                                                    <i className="fa fa-upload color-success fs-4" />
                                                </span>
                                            </Button>
                                            <Button
                                                className="btn-xs mb-2"
                                                variant="danger"
                                                onClick={RemoveImage}
                                            >
                                                <span className="">
                                                    <i className="fa fa-close color-danger fs-4" />
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                    {fileerrors.length > 0 && (
                                        <div className="text-danger mt-2">
                                            {fileerrors.map((error, index) => (
                                                <div key={index}>{error}</div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {errors.file && <div className="text-danger fs-8 mt-1">{errors.file}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Banner <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddBanner;
